import { render, staticRenderFns } from "./BolsosHome.vue?vue&type=template&id=9a12c338"
import script from "./BolsosHome.vue?vue&type=script&lang=js"
export * from "./BolsosHome.vue?vue&type=script&lang=js"
import style0 from "./BolsosHome.vue?vue&type=style&index=0&id=9a12c338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports